
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Table,
    Button,
    FormGroup,
    Label,
    Input,
    Spinner,
    Modal,
    ModalHeader,
    ModalBody,
    ButtonGroup
} from 'reactstrap';
import { toast } from 'react-toastify';
import { apiURL1 } from '../../config';
import { FaTimes, FaFilePdf, FaPrint, FaPencilAlt, FaTrash } from 'react-icons/fa';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import './ExamList.css';

const baseURL = apiURL1;

function AllExam({ exams, setExams, loading, setLoading, page, setPage, totalPages, setTotalPages, classId, setClassId, courseId, setCourseId, type, setType, year, setYear, classes, setClasses, deleteModal, setDeleteModal, examToDelete, setExamToDelete, courses, setCourses, fetchClasses, fetchExams, handleClassChange, handleCourseChange, handleTypeChange, handleYearChange, openDeleteModal, closeDeleteModal, handleDeleteExam, renderPagination }) {
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    const [examTypes, setExamTypes] = useState([]);
    const [madrasaInfo, setMadrasaInfo] = useState({
        schoolName: '',
        schoolAddress: '',
        schoolPhoneNumber: '',
        schoolEmail: ''
    });

    useEffect(() => {
        fetchExamTypes();
        fetchMadrasaInfo();
    }, []);

    const fetchMadrasaInfo = async () => {
        try {
            const response = await axios.get(`${baseURL}/superadmin/school-settings`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            });
            const data = response.data;
            if (data && data.length > 0) {
                setMadrasaInfo(data[0]);
            }
        } catch (error) {
            console.error('Error fetching madrasa info:', error);
        }
    };

    const fetchExamTypes = async () => {
        try {
            const response = await axios.get(`${baseURL}/superadmin/examType`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            });
            if (response.data && response.data.success && Array.isArray(response.data.data)) {
                setExamTypes(response.data.data);
            } else {
                setExamTypes([]);
                if (response.data && !response.data.success) {
                    toast.error(response.data.message || 'Failed to fetch exam types');
                }
            }
        } catch (error) {
            console.error('Error fetching exam types:', error);
            toast.error('Error fetching exam types');
            setExamTypes([]);
        }
    };

    useEffect(() => {
        fetchExams();
    }, [page, classId, courseId, type, year]);

    const generateExamReport = async () => {
        setLoading(true);
        try {
            let url = `${baseURL}/superadmin/filterExams`;
            const params = new URLSearchParams();
            if (classId) params.append('classId', classId);
            if (courseId) params.append('courseId', courseId);
            if (type) params.append('type', type);
            if (year) params.append('year', year);

            url += `?${params.toString()}`;

            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            // Fetch madrasa info first
            const madrasaResponse = await axios.get(`${baseURL}/superadmin/school-settings`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            const madrasaData = madrasaResponse.data[0] || {};

            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                params: { classId, courseId, type, year }
            };

            // console.log('Token is ', token)
            // Then fetch exams data
            const examsResponse = await axios.get(`${baseURL}/superadmin/filterExams`, config);
            const allExams = examsResponse.data.data;


            const doc = new jsPDF();

            // Add logo and school information
            const img = new Image();
            img.src = "https://res.cloudinary.com/djg7v9dna/image/upload/v1742946371/mi0wavjsehps20kdzaet.png";

            doc.addImage(img, 'PNG', 15, 15, 30, 30);

            doc.setFontSize(14);
            doc.text(madrasaData.schoolName || 'Ummu Dhardha Ladies Islamic College', 50, 20);

            doc.setFontSize(10);
            doc.text(madrasaData.schoolAddress, 50, 27);
            doc.text(`Phone: ${madrasaData.schoolPhoneNumber} | Email: ${madrasaData.schoolEmail}`, 50, 34);

            // Define the columns for the table
            const columns = ["Class", "Course", "Type", "Year", "Status"];

            // Prepare the data for the table
            const data = allExams.map(exam => [
                exam.class.className,
                exam.course.courseName,
                exam?.type?.name || "NA",
                exam.year,
                exam.status === 'draft' ? 'DRAFT' : 'PUBLISHED'
            ]);

            // Add the table to the PDF
            doc.autoTable({
                startY: 45,
                head: [columns],
                body: data,
                styles: { fontSize: 10, cellPadding: 3 },
                headStyles: { fillColor: [41, 128, 185], textColor: 255 }
            });

            // Save the PDF
            doc.save('exams_report.pdf');
        } catch (error) {
            console.error('Error generating exam report:', error);
            toast.error('Error generating exam report');
        } finally {
            setLoading(false);
        }
    }

    const handlePrint = () => {
        const tableStyle = `
      border-collapse: collapse;
      width: 100%;
      margin-top: 20px;
    `;

        const thStyle = `
      background-color: #2980b9;
      color: white;
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
    `;

        const tdStyle = `
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
    `;

        const printContent = `
      <div style="text-align: center; padding: 20px;">
        <img src="https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp" 
             alt="School Logo" 
             style="width: 100px; height: 100px; margin-bottom: 10px;">
        <h2>${madrasaInfo.schoolName || 'Ummu Dhardha Ladies Islamic College'}</h2>
        <p>${madrasaInfo.schoolAddress || 'Meera Nagar, Beach Road, Akkaraipattu. EP. 32400. Sri Lanka.'}</p>
        <p>Tel: ${madrasaInfo.schoolPhoneNumber || '+94 67 205 3211'} | Email: ${madrasaInfo.schoolEmail || 'info@ummudhardha.lk'}</p>
        <hr>
        <h3>Exams</h3>
        <table style="${tableStyle}">
          <thead>
            <tr style="${thStyle}">
              <th style="${thStyle}">Class</th>
              <th style="${thStyle}">Course</th>
              <th style="${thStyle}">Type</th>
              <th style="${thStyle}">Year</th>
              <th style="${thStyle}">Status</th>
            </tr>
          </thead>
          <tbody>
            ${exams.map(exam => `
              <tr key=${exam._id}>
                <td style="${tdStyle}">${exam.class.className}</td>
                <td style="${tdStyle}">${exam.course.courseName}</td>
                <td style="${tdStyle}">${exam?.type?.name || "NA"}</td>
                <td style="${tdStyle}">${exam.year}</td>
                <td style="${tdStyle}">${exam.status === 'draft' ? 'DRAFT' : 'PUBLISHED'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
<p style="margin-top: 20px; text-align: center;">
  Generated on: ${(() => {
                const d = new Date();
                const day = String(d.getDate()).padStart(2, '0');
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const year = d.getFullYear();
                return `${day}-${month}-${year}`;
            })()}
</p>
      </div>
    `;

        const printWindow = window.open('', '_blank');
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.print();
    };

    return (
        <Container>
            <Row className="mb-3 print-hidden">
                <Col md={3}>
                    <FormGroup>
                        <Label>Class</Label>
                        <Input type="select" value={classId} onChange={handleClassChange}>
                            <option value="">All Classes</option>
                            {classes.map((cls) => (
                                <option key={cls._id} value={cls._id}>
                                    {cls.className}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </Col>
                {courses.length > 0 && (
                    <Col md={3}>
                        <FormGroup>
                            <Label>Course</Label>
                            <Input
                                type="select"
                                value={courseId}
                                onChange={handleCourseChange}
                                disabled={courses.length === 1}
                            >
                                {courses.map((crs) => (
                                    <option key={crs._id} value={crs._id}>
                                        {crs.courseName}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>
                )}

                <Col md={3}>
                    <FormGroup>
                        <Label>Year</Label>
                        <Input
                            type="number"
                            placeholder="YYYY"
                            value={year}
                            onChange={handleYearChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card>
                        <CardHeader className="print-hidden" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3>Exams</h3>
                            <div>
                                <Button color="info" size="sm" onClick={handlePrint} style={{ marginRight: '10px' }}>
                                    Print
                                </Button>
                                <Button color="success" size="sm" onClick={generateExamReport} style={{ marginRight: '10px' }} disabled={loading}>
                                    {loading ? <Spinner size="sm" /> : <FaFilePdf />} Download
                                </Button>
                                <Button color="primary" onClick={() => navigate(`/admin/add-exam`)}>
                                    Add New
                                </Button>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <div className="print-only">
                                <h2>All Exams</h2>
                            </div>
                            {loading ? (
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Spinner color="primary" />
                                </div>
                            ) : (
                                <>
                                    {exams.length === 0 ? (
                                        <p>No exams found.</p>
                                    ) : (
                                        <Table className="table">
                                            <thead>
                                                <tr style={{ backgroundColor: '#2980b9', color: 'white' }}>
                                                    <th>Class</th>
                                                    <th>Course</th>
                                                    <th>Type</th>
                                                    <th>Year</th>
                                                    <th>Status</th>
                                                    <th className="print-hidden">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {exams.map((exam, index) => (
                                                    <tr key={exam._id} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white' }}>
                                                        <td>{exam.class.className}</td>
                                                        <td>{exam.course.courseName}</td>
                                                        <td>{exam?.type?.name || "NA"}</td>
                                                        <td>{exam.year}</td>
                                                        <td>{exam.status === 'draft' ? 'DRAFT' : 'PUBLISHED'}</td>
                                                        <td className="print-hidden">
                                                            <ButtonGroup size="sm">
                                                                <Button color="info" className="mr-1" onClick={() => navigate(`/admin/view-exam/${exam._id}`)} >
                                                                    View
                                                                </Button>
                                                                <Button color="warning" className="mr-1" onClick={() => navigate(`/admin/edit-exam/${exam._id}`)}>
                                                                    <FaPencilAlt />
                                                                </Button>
                                                                <Button color="danger" className="mr-1" onClick={() => openDeleteModal(exam._id)}>
                                                                    <FaTrash />
                                                                </Button>
                                                            </ButtonGroup>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </>
                            )}
                            {renderPagination()}
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Delete Exam Modal */}
            <Modal isOpen={deleteModal} toggle={closeDeleteModal}>
                <ModalHeader toggle={closeDeleteModal}>
                    Delete Exam
                    <Button
                        className="close"
                        onClick={closeDeleteModal}
                        style={{ position: 'absolute', top: '10px', right: '10px' }}
                    >
                        <FaTimes />
                    </Button>
                </ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this exam?</p>
                    <Button color="danger" onClick={handleDeleteExam}>
                        Yes, Delete
                    </Button>
                    <Button color="secondary" onClick={closeDeleteModal}>
                        Cancel
                    </Button>
                </ModalBody>
            </Modal>
        </Container>
    );
}

export default AllExam;
